import { useEffect, useState } from 'react'

import { GemfuryPackage } from '@instabox/lockers-update-common/types'

import fetch from '../fetch'

export default function usePackages(): {
  packages: GemfuryPackage[]
  loading: boolean
  reload: (shouldLoad?: boolean, refresh?: boolean) => Promise<void>
} {
  const [packages, setPackages] = useState<GemfuryPackage[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getPackages = async (shouldLoad = true, refresh = false): Promise<void> => {
    setLoading(shouldLoad)

    try {
      const response = await fetch(`/api/package?refresh=${refresh}`)

      if (!response.ok) {
        return
      }

      const data = await response.json()

      setPackages(data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPackages().catch(console.error)
  }, [])

  return { packages, loading, reload: (shouldLoad = false, refresh = false) => getPackages(shouldLoad, refresh) }
}
